/*
 * Golf 360 - Variant price fix for price-hidden ("request a quote") products.
 * Updates the static #product-price block on variant change for products
 * rendered with data-should-show-price="false". Normal products are untouched.
 * Self-contained; safe to load site-wide. Added 2026-06.
 */
(function () {
  'use strict';
  function init() {
    var productPage = document.querySelector('product-page[data-should-show-price="false"]');
    var priceBox = document.getElementById('product-price');
    if (!productPage || !priceBox) return; // only price-hidden product pages
    var handle = (location.pathname.split('/products/')[1] || '').split('/')[0].split('?')[0];
    if (!handle) return;
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) { wire(product, priceBox); })
      .catch(function () {});
  }
  function wire(product, priceBox) {
    var variants = product.variants;
    var writing = false;
    function money(cents) {
      if (window.Shopify && Shopify.formatMoney && Shopify.money_format) {
        try { return Shopify.formatMoney(cents, Shopify.money_format); } catch (e) {}
      }
      return '$' + (cents / 100).toFixed(2);
    }
    function currentVariant() {
      var checked = [].slice.call(
        document.querySelectorAll('.product-variant__input:checked')
      ).map(function (i) { return i.value; });
      if (checked.length) {
        var match = variants.filter(function (v) {
          return checked.every(function (val) { return v.options.indexOf(val) !== -1; });
        });
        if (match[0]) return match[0];
      }
      var id = new URLSearchParams(location.search).get('variant');
      return variants.filter(function (v) { return String(v.id) === id; })[0];
    }
    function render() {
      var v = currentVariant();
      if (!v) return;
      var orig = priceBox.querySelector('.product-price--original');
      if (!orig) return;
      var target = money(v.price);
      if (orig.textContent.indexOf(target) !== -1) return; // already correct; avoids observer loop
      writing = true;
      var label = orig.querySelector('.visually-hidden');
      orig.textContent = '';
      if (label) orig.appendChild(label);
      orig.appendChild(document.createTextNode(' ' + target + ' '));
      writing = false;
    }
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('product-variant__input')) {
        setTimeout(render, 0);
      }
    });
    new MutationObserver(function () { if (!writing) setTimeout(render, 0); })
      .observe(priceBox, { childList: true, subtree: true, characterData: true });
    render();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
